/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */

var $ = require('jquery');

function useSpecificPlaceholder(code) {
    var theForm = $('#' + code + 'form');
    var theField = theForm.find('.verificationCode');
    theField.attr('placeholder', theField.attr('specificplaceholder'));
}

function useGenericPlaceholder(code) {
    var theForm = $('#' + code + 'form');
    var theField = theForm.find('.verificationCode');
    theField.attr('placeholder', theField.attr('genericplaceholder'));
}

module.exports = {
    useSpecificPlaceholder: useSpecificPlaceholder,
    useGenericPlaceholder: useGenericPlaceholder,
};
